(function ($) {
    'use strict';

    /**
     * Инициализирует модуль
     */
    document.addEventListener('DOMContentLoaded', () => {
        let multilevelList = new MultilevelList();
    });

    function MultilevelList() {
        this.onLoad();
        this.onItemClick();
        this.onButtonShowListClick();
        this.onButtonRepackageClick();
    }

    /**
     * Обработчик события: клик по элементу многоуровневого списка
     *
     */
    MultilevelList.prototype.onItemClick = function () {
        $(document).off('click', '.multilevel-list__item__title-link');
        $(document).on('click', '.multilevel-list__item__title-link', (e) => {
            e.preventDefault();

            let $element = $(e.target);
            let $item = this.getItemByChild($element);
            if ($item.attr('data-is-parent') !== '1') {
                let itemData = this.getDataFromItem($item);
                $.publish('multilevel-list:item-is-selected', [itemData]);
                return;
            }

            this.load(
                this.getMultilevelListByChild($element),
                e.target.href
            );
        });
    };

    /**
     * Обработчик события: клик по кнопке отобразить список
     *
     */
    MultilevelList.prototype.onButtonShowListClick = function () {
        $(document).off('click', '.multilevel-list__item__btn-show-list');
        $(document).on('click', '.multilevel-list__item__btn-show-list', (e) => {
            e.preventDefault();

            let $item = this.getItemByChild($(e.target));
            let itemData = this.getDataFromItem($item);

            $.publish('multilevel-list:item-is-selected', [itemData]);
        });
    };

    /**
     * Обработчик события: клик по кнопке перепаковать
     *
     */
    MultilevelList.prototype.onButtonRepackageClick = function () {
        $(document).off('click', '.multilevel-list__item__btn-repackage');
        $(document).on('click', '.multilevel-list__item__btn-repackage', (e) => {
            e.preventDefault();

            let $link = e.target.href;

            $.get($link, {}, function(response) {
                if (response.result === 'error') {
                    alert('Ошибка!');

                    return;
                }

                alert('Архив пересобран!');
            }, 'json');
        });
    };

    /**
     * Производит подписку на обработку события загрузить данные многоуровый спискок
     *
     */
    MultilevelList.prototype.onLoad = function () {
        var subscribeEventName = 'multilevel-list:load';

        $.unsubscribe(subscribeEventName);
        $.subscribe(subscribeEventName, (e, listName, url) => {
            console.log('event-received: ' + subscribeEventName);

            let $multilevelList = this.getMultilevelListByName(listName);
            if ($multilevelList.length && !url) {
                url = $multilevelList.attr('data-url');
            }

            this.load(
                $multilevelList,
                url
            );

        });
    };

    /**
     * Возвращает элемент списка по его дочернему элементу
     *
     * @param {jQuery} $childElement Ссылка на дочерний элемент
     *
     * @return {jQuery}
     */
    MultilevelList.prototype.getItemByChild = ($childElement) => $childElement.closest('.multilevel-list__item');

    /**
     * Возвращает элемент являющимся контейнером списка по его дочернему элементу
     *
     * @param {jQuery} $childElement Ссылка на дочерний элемент
     *
     * @return {jQuery}
     */
    MultilevelList.prototype.getMultilevelListByChild = ($childElement) => $childElement.closest('.multilevel-list');

    /**
     * Возвращает элемент являющимся контейнером списка по его названию
     *
     * @param {String} name Название
     *
     * @return {jQuery}
     */
    MultilevelList.prototype.getMultilevelListByName = (name) => $(`.multilevel-list[data-type="${name}"]`);

    /**
     * Возвращает тип многоуровневого списка по дочернему элементу списка
     *
     * @param {jQuery} $childElement Ссылка на дочерний элемент
     *
     * @return {String}
     */
    MultilevelList.prototype.getNameByChild = function ($childElement) {
        let $multilevelList = this.getMultilevelListByChild($childElement);

        return this.getName($multilevelList);
    };

    /**
     * Возвращает тип многоуровневого списка по дочернему элементу списка
     *
     * @param {jQuery} $multilevelList Ссылка на многоуровневый список
     *
     * @return {String}
     */
    MultilevelList.prototype.getName = function ($multilevelList) {
        if (!$multilevelList.length) {
            return '';
        }

        return $multilevelList.data('type');
    };

    /**
     * Возвращает данные указанные в DOM-элементе многоуровневого списка
     *
     * @param {jQuery} $item Ссылка на DOM-элемент
     *
     * @return {Object|Boolean}
     */
    MultilevelList.prototype.getDataFromItem = function ($item) {
        if (!$item.length) {
            return false;
        }

        return {
            $multilevelList: this.getMultilevelListByChild($item),
            multilevelListType: this.getNameByChild($item),
            $element: $item,
            code: $item.attr('data-code'),
            name: $.trim($item.find('.multilevel-list__item__title').text()),
            parentCode: $item.attr('data-parent-code'),
            isParent: $item.attr('data-is-parent')
        };
    };

    /**
     * Загружает данные в список
     *
     * @param {jQuery} $multilevelList Сыылка на список
     * @param {String} url Ссылка, по которой нужно загрузить данные
     */
    MultilevelList.prototype.load = function ($multilevelList, url) {
        if (!$multilevelList.length) {
            console.warn('MultilevelList not found');
            return;
        }
        if (!url) {
            console.warn('Unknown url');
            return;
        }

        $multilevelList.addClass('is-loading');
        $multilevelList.html('');
        $multilevelList.addClass('show');
        $.get(url, {'multilevel_list': 1}, (response) => {
            if (!this._processingResponse(response)) {
                return;
            }

            $multilevelList.html(response.data);
            $multilevelList.removeClass('is-loading');

            $.publish('multilevel-list:loaded', [this.getName($multilevelList), response.parent_item, response.pageHeading]);
        }, 'json');
    };

    MultilevelList.prototype._processingResponse = function (response) {
        let isError = !response.hasOwnProperty('data') || !response.hasOwnProperty('parent_item');
        if (!isError) {
            return true;
        }

        let message = 'Ошибка!';

        if (response.hasOwnProperty('message') && response.message.length) {
            message = response.message;
        }

        noty({
            text: message,
            type: 'error',
            speed: 500,
            timeout: 4000
        });

        return false;
    }

})(window.jQuery);